import {Component, computed, effect, inject, input, model, OnDestroy, OnInit, untracked} from '@angular/core';
import {LucideAngularModule, LucideIconData} from 'lucide-angular';
import {TabsService} from '@shared/container/tabs/tabs.service';

@Component({
  selector: 'app-tab-item',
  imports: [
    LucideAngularModule
  ],
  templateUrl: './tab-item.component.html',
  styleUrl: './tab-item.component.scss'
})
export class TabItemComponent implements OnInit, OnDestroy {
  // public readonly open = model<boolean>(false);
  public readonly icon = input<LucideIconData | null>(null);
  public readonly title = input('');
  public readonly selected = model(false);
  public readonly isInvalid = input(false);
  public readonly isSelected = computed(() => this.tabsService.selectedTab() === this);

  private readonly tabsService = inject(TabsService);

  constructor() {
    // 1. Sync: Parent (model) -> Service
    effect(() => {
      const shouldBeSelected = this.selected();

      // 'untracked' prevents the effect from re-running if
      // the service state changes later.
      untracked(() => {
        if (shouldBeSelected !== this.isSelected()) {
          this.tabsService.setSelected(this, shouldBeSelected);
        }
      });
    });

    // 2. Sync: Service -> Parent (model)
    effect(() => {
      const internalState = this.isSelected();
      untracked(() => {
        if (internalState !== this.selected()) {
          this.selected.set(internalState);
        }
      });
    });
  }

  public ngOnInit() {
    this.tabsService.registerTab(this);
  }

  public ngOnDestroy() {
    this.tabsService.unregisterTab(this);
  }
}
